import React from 'react';
import { Menu, Card } from 'antd';
import app from 'xadmin';
import models from './models';
import { HasPermission } from 'xadmin-auth';
import { Icon, C } from 'xadmin-ui';
import { Model } from 'xadmin-model';
import './../guide/css/index.css'  // 用户有创建权限,不显示添加日志按钮

import ClearLogBtn from './component/ClearLogBtn'
import ArchiveDropdown from './ArchiveBtn'
import YmdwwpsPicker from './component/YmdwwpsPicker'
import { LogPage } from './models'
import { ReductionBtn } from './ArchiveBtn'
import { addExporImportLog } from './hooks'
import LoginExport from './LoginExport';

export default {
  name: 'iot.log',
  components: { ClearLogBtn, YmdwwpsPicker, 'Log.YmdwwpsPicker': YmdwwpsPicker, ArchiveDropdown, LogPage, ReductionBtn, LoginExport },
  blocks: {
    'dashboard.main': () => ([
      <Card bodyStyle={{ padding: 15, marginBottom: 10 }} title="操作日志">
        <Model name="Log" modelKey="Log_"  >
          <C is="Model.DataTable" size="small" /><br></br>
          <div key="model-list-subnav" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '.5rem' }}>
            <C is="Model.Pagination" />
            <C is="Model.ListSubMenu" />
          </div>
        </Model>
      </Card>, <br />,
      <Card bodyStyle={{ padding: 15 }} title="资产增加">
        <Model name="Node" modelKey="Node" initialValues={{
          filter: { order: { 'createTime': 'DESC' } }
        }}>
          <C is="Model.DataTable" size="small" /><br></br>
          <div key="model-list-subnav" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '.5rem' }}>
            <C is="Model.Pagination" />
            <C is="Model.ListSubMenu" />
          </div>
        </Model>
      </Card>
    ])
  },
  menuItems: [
    {
      title: '日志管理', parent: 'business', icon: 'Log', permission: 'log.view', children: [
        { title: '操作日志', url: '/app/model/Log/list', icon: 'Log', permission: 'log.view', },
        { title: '接口调用日志', url: '/app/model/Apimonitor/list', icon: 'Log', permission: 'apimonitor.view', },
        { title: '越权访问日志', parent: 'business', url: '/app/model/Apipermission/list', icon: 'Log', permission: 'apipermission.view' }
      ]
    }
  ],
  frontMenuItems: [
    { title: '操作日志', url: '/app/model/Log/list', icon: 'Log', permission: 'log.view' }
  ],
  routers: {
    '/app/': [
      {
        path: 'log'
      },
    ]
  },
  models,
  hooks: {
    'log.exporImport': props => {
      return { addExporImportLog }
    }
  }
}

